export var UploadHeaders;
(function (UploadHeaders) {
    UploadHeaders["PAID_BY"] = "x-irys-paid-by";
})(UploadHeaders || (UploadHeaders = {}));
//# sourceMappingURL=types.js.map